import React from 'react';
import UserLayout from '../../components/Layout/UserLayout';
import TrustAndVerification from './TrustAndVerification';
import { emailVerification } from '../../actions/manageUserVerification';
import { loadAccount } from '../../actions/account';

const title = 'Trust and Verification';

export default async function action({ store, query }) {

  // From Redux Store
  let isAuthenticated = store.getState().runtime.isAuthenticated;

  if (!isAuthenticated) {
    if ('confirm' in query && 'email' in query) {
      //return { redirect: '/login?verification=email' };
      return { redirect: "/login?refer=/user/verification------confirm=" + query.confirm + "--email=" + query.email };
    }
    return { redirect: '/login' };
  }

  // Get account data safely
  let accountData = store.getState().account?.data;

  // If account data is not loaded, load it now (happens during client-side navigation)
  if (!accountData || !accountData.userId) {
    await store.dispatch(loadAccount());
    accountData = store.getState().account?.data;
  }

  // If still no account data after loading, redirect to login
  if (!accountData || !accountData.userId) {
    return { redirect: '/login' };
  }

  let userId = accountData.userId;

  if ('confirm' in query && 'email' in query) {
    store.dispatch(emailVerification(query.confirm, query.email, userId));
  }

  return {
    title,
    component: <UserLayout><TrustAndVerification title={title} /></UserLayout>,
  };
};
